exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BrandCampaignEditPage textarea {\n  min-height: 100px;\n}\n.BrandCampaignEditPage h4 {\n  margin: 40px 0 20px 0;\n}\n", ""]);

// exports
